/**
 * Owner Status Filter Enum
 *
 * @type {{ALL: string, OWNER: string, NOT_OWNER: string}}
 */
export const OWNER_STATUS_FILTER_ENUM = {
  ALL: 'ALL',
  OWNER: 'OWNER',
  NOT_OWNER: 'NOT_OWNER',
};

/**
 * Owner Status Filter Enum labels
 *
 * @type {{ALL: string, OWNER: string, NOT_OWNER: string}}
 */
export const OWNER_STATUS_FILTER_ENUM_LABELS = {
  [OWNER_STATUS_FILTER_ENUM.ALL]: 'All events',
  [OWNER_STATUS_FILTER_ENUM.OWNER]: 'Owned events',
  [OWNER_STATUS_FILTER_ENUM.NOT_OWNER]: 'Shared events',
};

/**
 * Hierarchy group sortable fields enum
 *
 * @type {{CREATED_AT: string, VIEWED_AT: string}}
 */
export const HIERARCHY_GROUP_SORTABLE_FIELDS = {
  CREATED_AT: 'CREATED_AT',
  VIEWED_AT: 'VIEWED_AT',
  NAME: 'NAME',
  UPDATED_AT: 'UPDATED_AT',
};

/**
 * Hierarchy group sortable fields labels
 *
 * @type {{CREATED_AT: string, VIEWED_AT: string, NAME: string, UPDATED_AT: string}}
 */
export const HIERARCHY_GROUP_SORTABLE_FIELDS_LABEL = {
  [HIERARCHY_GROUP_SORTABLE_FIELDS.CREATED_AT]: 'Recently created',
  [HIERARCHY_GROUP_SORTABLE_FIELDS.VIEWED_AT]: 'Recently viewed',
  [HIERARCHY_GROUP_SORTABLE_FIELDS.NAME]: 'Event name',
  [HIERARCHY_GROUP_SORTABLE_FIELDS.UPDATED_AT]: 'Recently updated',
};

/**
 * Active button type enum
 *
 * @type {{NONE: string, SEARCH: string, FILTER: string}}
 */
export const ACTIVE_BUTTON_TYPE = {
  NONE: 'none',
  SEARCH: 'search',
  FILTER: 'filter',
};
